<template>
  <div class="profile-research">
    <div v-if="store.getters.enableScientificScopes">
      <scientific-scopes title="Научные направления" />
    </div>

    <profile-table-layout
      title="Активные проекты"
      :get-items="api.project.profileProjects"
      :url-params="urlParamsActive"
      entity="projects"
    >
      <template #table-item="slotProps">
        <profile-projects-active-project-item :item="slotProps.item" />
      </template>
    </profile-table-layout>

    <profile-table-layout
      title="Архивные проекты"
      :get-items="api.project.profileProjects"
      :url-params="urlParamsArchive"
      entity="projects"
    >
      <template #table-item="slotProps">
        <profile-projects-active-project-item :item="slotProps.item" />
      </template>
    </profile-table-layout>

    <profile-table-layout
      :title="'Публикации'"
      :get-items="api.person.profilePublications"
      entity="publications"
    >
      <template #table-item="slotProps">
        <profile-research-publication-item :item="slotProps.item" />
      </template>
    </profile-table-layout>
  </div>
</template>

<script setup>
  import ProfileTableLayout from '@/components/profile/ProfileTableLayout.vue';
  import ProfileResearchPublicationItem from '@/components/profile/research/ProfileResearchPublicationItem.vue';
  import { useApi } from '@/api/use-api';
  import store from '@/store';
  import ScientificScopes from '@/components/profile/projects/scientific-scopes/ScientificScopes.vue';
  import ProfileProjectsActiveProjectItem from '@/components/profile/projects/active-project/ProfileProjectsActiveProjectItem.vue';
  import {
    PROFILE_PROJECT_STATE_ACTIVE,
    PROFILE_PROJECT_STATE_ARCHIVE,
  } from '@/constants/profile-project-state';

  const api = useApi();

  const urlParamsActive = new URLSearchParams({
    state: PROFILE_PROJECT_STATE_ACTIVE,
  });
  const urlParamsArchive = new URLSearchParams({
    state: PROFILE_PROJECT_STATE_ARCHIVE,
  });
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .profile-research {
    margin-top: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-bottom: 100px;
  }
</style>
